import { theme } from "styles/mui-config";
import styled from "styled-components";
import CardMedia from "@mui/material/CardMedia";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import AccordionSummary from "@mui/material/AccordionSummary";

export const StyledCardMedia = styled(CardMedia)`
  height: 200px;
`;
export const StyledAvatar = styled(Avatar)`
  background: ${theme.palette.primary.main} !important;
`;
export const StyledTypography = styled(Typography)`
  font-size: 14px !important;
`;
export const StyledarticlePic = styled.div`
  height: 280px;
  overflow: hidden;
  display: flex;
  align-items: center;
  & img {
    width: 100%;
    height: auto;
  }
  & video {
    width: 100%;
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  direction: rtl;
  & div:first-child {
    margin: 3px;
    margin-right: 0;
  }
  & div > p {
    font-size: 14px;
    color: #676767;
  }
`;
